import type { ReactElement, ReactNode } from 'react';

export type BadgeTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'accent';

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
}

/**
 * Colour is never the only signal — a badge always carries a word, because a
 * site manager reads this in sunlight on a scratched screen.
 */
export function Badge({ tone = 'neutral', children }: BadgeProps): ReactElement {
  return <span className={`badge badge--${tone}`}>{children}</span>;
}
